module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"from {qty_min} pieces {price_fix} CHF":"from {qty_min} pieces {price_fix} CHF","from {qty_min} pieces {price_recurring} CHF":"from {qty_min} pieces {price_recurring} CHF"},"de":{"from {qty_min} pieces {price_fix} CHF":"ab {qty_min} Stück {price_fix} CHF","from {qty_min} pieces {price_recurring} CHF":"ab {qty_min} Stück {price_recurring} CHF"}}')
  delete Component.options._Ctor
}
